'use client';

/**
 * 알림 구독을 «권했는지·사용자가 어떻게 답했는지» 의 기록. (#264)
 *
 * 왜 필요한가: 구독 권유를 업데이트 메뉴에만 두었더니 그 메뉴에 잘 들어가지 않아
 * 사실상 아무도 보지 못했다. 그래서 맞춤법 검사·형태분석에 들어올 때 권하는데,
 * 매번 권하면 도구를 쓰러 온 사람을 가로막는 잔소리가 된다. **기록이 없을 때만**
 * 한 번 권한다.
 *
 * 구독 여부 자체는 브라우저(PushManager)가 알고 있으므로 여기 저장하지 않는다.
 * 여기 남기는 것은 '물어봤고 답을 받았다'는 사실뿐이다 — 사용자가 나중에 구독을
 * 해제해도 다시 붙잡지 않는다(권유 창구는 업데이트 메뉴에 그대로 있다).
 */

const RECORD_KEY = 'push-opt-in:decision';

export type PushOptInDecision = 'subscribed' | 'dismissed';

/** 이미 한 번 권했고 답을 받았는가. 판단할 수 없으면 `true`(권하지 않는다). */
export function hasPushOptInRecord(): boolean {
  if (typeof window === 'undefined') return true;
  try {
    return !!window.localStorage.getItem(RECORD_KEY);
  } catch {
    // localStorage 를 못 쓰는 환경(시크릿 모드 등)에서는 기록을 남길 수 없다.
    // 그런 곳에서 권하면 방문마다 다시 뜨므로 아예 권하지 않는다.
    return true;
  }
}

export function recordPushOptInDecision(decision: PushOptInDecision): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(RECORD_KEY, decision);
  } catch {
    // 기록을 못 남기면 다음 방문에 또 뜬다 — 그래도 기능은 정상이므로 무시한다.
  }
}
